import * as Yup from 'yup'
import { Col, Form, Row } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';
import { checkRequiredText } from '../ValidationRules';
export const characterRestrictionRegExp = /^[a-zA-Z0-9äöüÄÖÜßé '.,!?&_/\-()]+$/i;

export const Schema = (settings) => Yup.object().shape({
    emailAddress: Yup.string()
        .email("Bitte geben Sie eine gültige E-Mail-Adresse an")
        .required("Angabe ist erforderlich"),
    street: Yup.string()
        .required("Angabe ist erforderlich")
        .when("settings.isUnicode", {
            is: () => !settings.isUnicode,
            then: Yup.string().matches(characterRestrictionRegExp, "Bitte geben Sie einen gültigen Wert an")
        })
        .max(30,"Es können maximal 30 Zeichen eingegeben werden"),
    postalCode: Yup.string()
        .required("Angabe ist erforderlich")
        .when("settings.isUnicode", {
            is: () => !settings.isUnicode,
            then: Yup.string().matches(characterRestrictionRegExp, "Bitte geben Sie einen gültigen Wert an")
        })
        .max(8,"Es können maximal 8 Zeichen eingegeben werden"),
    city: Yup.string()
        .required("Angabe ist erforderlich")
        .when("settings.isUnicode", {
            is: () => !settings.isUnicode,
            then: Yup.string().matches(characterRestrictionRegExp, "Bitte geben Sie einen gültigen Wert an")
        })
        .max(30,"Es können maximal 30 Zeichen eingegeben werden"),
    phoneNumber: Yup.string()
        .matches(RegExp(settings.applicationPhoneNumberRegex), "Ungültige Telefonnummer")
        .required("Angabe ist erforderlich"),
});

export const ContactSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formStreet">
                <Form.Label>Straße und Hausnummer*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Straße und Hausnummer eingeben"
                    type="text"
                    name="street"
                    value={values.street}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onInput={handleBlur}
                    isValid={touched.street && !errors.street}
                    isInvalid={touched.street && errors.street}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.street}
                </Form.Control.Feedback>
            </Form.Group>

            <Row className="mb-3">
                <Form.Group as={Col} md={3} controlId="formPostalCode">
                    <Form.Label>PLZ*</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Postleitzahl"
                        type="text"
                        name="postalCode"
                        value={values.postalCode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onInput={handleBlur}
                        isValid={touched.postalCode && !errors.postalCode}
                        isInvalid={touched.postalCode && errors.postalCode}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.postalCode}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} md={9} controlId="formCity">
                    <Form.Label>Ort*</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Ort eingeben"
                        type="text"
                        name="city"
                        value={values.city}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onInput={handleBlur}
                        isValid={touched.city && !errors.city}
                        isInvalid={touched.city && errors.city}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.city}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>

            <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label>E-Mail*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="E-Mail eingeben"
                    type="email"
                    name="emailAddress"
                    value={values.emailAddress}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.emailAddress && !errors.emailAddress}
                    isInvalid={touched.emailAddress && errors.emailAddress}
                    maxLength={settings.emailInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.emailAddress}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formPhoneNumber">
                <Form.Label>Telefon*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Telefon eingeben"
                    type="text"
                    name="phoneNumber"
                    value={values.phoneNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.phoneNumber && !errors.phoneNumber}
                    isInvalid={touched.phoneNumber && errors.phoneNumber}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.phoneNumber}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};